import { render, staticRenderFns } from "./myPagin.vue?vue&type=template&id=4062ef96&scoped=true&"
import script from "./myPagin.vue?vue&type=script&setup=true&lang=js&"
export * from "./myPagin.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./myPagin.vue?vue&type=style&index=0&id=4062ef96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4062ef96",
  null
  
)

export default component.exports